import React from "react";
import MListItemButton from "@mui/material/ListItemButton";

const ListItemButton = (props) => {
    return <MListItemButton {...props} />
}

export default React.memo(ListItemButton);